/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Constants used on the client-side: duplicated from server-side code
export const DEFAULT_PLUGIN_ID = 'default';
